/**
 * Préférences locales (gare favorite, calques actifs). Jamais transmises au serveur.
 * Toutes les opérations tolèrent un stockage indisponible (navigation privée, quotas).
 */
const PREFIX = 'ermont-live:';

export function readPreference<T>(key: string, fallback: T, isValid: (value: unknown) => value is T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    if (raw === null) return fallback;
    const parsed: unknown = JSON.parse(raw);
    return isValid(parsed) ? parsed : fallback;
  } catch {
    return fallback;
  }
}

export function writePreference(key: string, value: unknown): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // Stockage indisponible : la préférence ne sera simplement pas mémorisée.
  }
}
